/* Custos diretos do projeto: as cinco linhas fixas, cada uma com a regra dita
 * em texto e o valor resolvido no exemplo. Configurar abre o modal do index.
 * O custo do kit não está aqui: ele se informa em cada projeto. */

import { custoConfig } from '@favo/core';
import { Settings2 } from 'lucide-react';

import { Button } from '@/componentes/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/componentes/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/componentes/ui/table';
import { Valor } from '@/componentes/valor';
import type { ChaveCustoDireto, ConfigCusto } from '@/dados';

import { CAMPOS, descreverRegra, type Edicao } from './configuracao';

export function Diretos({
  campos,
  kwpRef,
  modulosRef,
  aoConfigurar,
}: {
  campos: Partial<Record<ChaveCustoDireto, ConfigCusto>>;
  kwpRef: number | null;
  modulosRef: number | null;
  aoConfigurar: (edicao: Edicao) => void;
}) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Custos diretos do projeto</CardTitle>
        <CardDescription>
          Custos que dependem do projeto e são conhecidos antes de fechar a venda. Custo sem
          configuração vale zero no preço. O custo do kit não entra aqui: ele vem do orçamento da
          distribuidora e se informa em cada projeto.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Custo</TableHead>
              <TableHead>Regra</TableHead>
              <TableHead className="text-right">No exemplo</TableHead>
              <TableHead className="w-0" />
            </TableRow>
          </TableHeader>
          <TableBody>
            {CAMPOS.map(({ chave, rotulo }) => {
              const cfg = campos[chave];
              return (
                <TableRow key={chave}>
                  {/* Prosa quebra linha: o nowrap padrão de TableCell é
                      para número, e frase sem quebra empurra a tabela
                      além da coluna (o overflow que esta etapa teve). */}
                  <TableCell className="align-top whitespace-normal">
                    <div className="text-corpo font-semibold">{rotulo}</div>
                  </TableCell>
                  <TableCell className="align-top whitespace-normal">
                    <span
                      className={
                        cfg?.modo ? 'text-apoio' : 'text-muted-foreground text-apoio italic'
                      }
                    >
                      {descreverRegra(cfg)}
                    </span>
                  </TableCell>
                  <TableCell className="text-right align-top">
                    <Valor
                      valor={custoConfig(cfg, kwpRef ?? 0, modulosRef ?? 0)}
                      formato="moeda"
                    />
                  </TableCell>
                  <TableCell className="align-top">
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() =>
                        aoConfigurar({
                          chave,
                          titulo: rotulo,
                          cfg: cfg ?? { modo: 'fixo' },
                          configurado: Boolean(cfg?.modo),
                        })
                      }
                    >
                      <Settings2 />
                      Configurar
                    </Button>
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
